import { Injectable } from "@angular/core";
import { ApiService } from "./api";

@Injectable({ providedIn: 'root' })
export class StreamSourceService {

    constructor(private api: ApiService) {}

    searchStreamSources = (key, value) => this.api.get('/ws/stream_source', this.api.paramify({ key: key, value: value }));
}